import React from 'react';

/** Enable/disable switch used in both the list and details views. */
export const EnableToggle: React.FC<{
  enabled: boolean;
  disabled?: boolean;
  onToggle: () => void;
}> = ({ enabled, disabled, onToggle }) => (
  <button
    onClick={(e) => {
      e.stopPropagation();
      onToggle();
    }}
    disabled={disabled}
    title={enabled ? 'Disable server' : 'Enable server'}
    className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${
      enabled ? 'bg-bg-brand-solid' : 'bg-bg-quaternary'
    }`}
  >
    <span
      className={`inline-block h-4 w-4 transform rounded-full bg-white shadow transition-transform ${
        enabled ? 'translate-x-[18px]' : 'translate-x-[2px]'
      }`}
    />
  </button>
);

export default EnableToggle;
